module.exports = __webpack_public_path__ + "img/commpany.0d8d8f48.webp";